import React from 'react';
import './global.css';

export const MatxLayouts = { layout1: React.lazy(() => import('./Layout1/Layout1')) };
